import { useState, useEffect } from 'react';

import { getLSValue, setLSValue } from '../utils/locale-storage';

const useLocalStorage = <T>(key: string, initialValue: T) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    let currentValue;

    try {
      const value: unknown = getLSValue(key, true);
      currentValue = value !== null ? (value as T) : initialValue;
    } catch (error: unknown) {
      currentValue = initialValue;
    }

    return currentValue;
  });
  useEffect(() => {
    setLSValue(key, storedValue);
  }, [key, storedValue]);
  return [storedValue, setStoredValue] as const;
};

export { useLocalStorage };
